import { i18n } from '@/locales';
const { t } = i18n;
const lc = 'views.worker_management.';
const limitCountItems = [
    0,
    5,
    10,
    15,
    20,
    25,
    30,
    35,
    40,
    45,
    50,
];
const result = {};
limitCountItems.forEach((code, index) => {
    result[code] = {
        text: t(`${lc}accepted_order_view_limit_count_code_text[${index}]`),
        value: code,
    };
});
export default result;
